module.exports = __webpack_public_path__ + "c6559f0922fafc0d0e79945d3bf7bcf1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/eyelashes.png
// module id = 1812
// module chunks = 0